var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"loading":_vm.loading,"title":"Busca de CID","large":"","hide-footer":""}},[_c('List',{ref:"Form",attrs:{"procedimento-id":_vm.procedimentoId,"principal":_vm.principal},on:{"select":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }